<!-- For usage instructions see  https://material.io/components/chips/ -->
<template>
    <div :class="['chip', className]">
        <!-- @slot The default slot for the element -->
        <slot></slot>       
    </div>
</template>

<script>
export default {
    props: {
        /**
            * @ignore This prop is not used
            */
        id: {
            type: String,
            default: ''
        },
        /**
            * A specific css class to add to the elment
            */
        className: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            selected: this.isSelected,
        };
    }
};
</script>